import {
  Box,
  Button,
  Checkbox,
  FormControl,
  MenuItem,
  Select,
  Typography
} from "@mui/material";
import PropTypes from "prop-types";
import { useCallback, useEffect, useState } from "react";

function BudgetRequestListToolbar({
  setIsForm,
  setActionButton,
  selectedCustomerIds,
  setTextosearch,
  statusStateOptions,
  setIsFilter,
  quantityFiltered,
  changeFilter,
}) {
  const getActionButton = useCallback(
    (item) => {
      if (item.length === 0) {
        setActionButton({ id: 1, text: "Adicionar Produto" });
      } else if (item.length === 1) {
        setActionButton({ id: 2, text: "Editar Produto" });
      } else if (item.length > 1) {
        setActionButton({ id: 3, text: "Excluir Produtos" });
      }
    },
    [setActionButton]
  );

  useEffect(() => {
    getActionButton(selectedCustomerIds);
  }, [selectedCustomerIds, getActionButton]);

  const [selectedStatus, setSelectedStatus] = useState([]);

  const clearFilter = () => {
    changeFilter("clerk", "");
    changeFilter("client", "");
    changeFilter("check_in", "");
    changeFilter("check_out", "");
    changeFilter("motivo", 0);
    changeFilter("midia", 0);
    changeFilter("motivo_cancelamento", 0);
    changeFilter("adults_quantity", 0);
    changeFilter("children_quantity", 0);
    changeFilter("babies_quantity", 0);
    changeFilter("price_up", null);
    changeFilter("price_down", null);
    changeFilter("status", []);
    changeFilter("has_motivo_cancelamento", 0);
    setSelectedStatus([]);
  };

  const handleChangeFilteredStatus = (option) => {
    const newSelectedStatus = Array.isArray(option) ? option : [option];
    setSelectedStatus(newSelectedStatus);

    const motivos = statusStateOptions
      .filter((opt) => newSelectedStatus.includes(opt.id_state))
      .map(opt => opt.id_state)

    const incluiCancelamento = newSelectedStatus.includes(4);

    changeFilter("status", motivos);
    changeFilter("has_motivo_cancelamento", incluiCancelamento ? 1 : 0);
  };

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ width: "100%", display: "flex" }}>
        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "flex-start" }}
        >
          <Box sx={{ mt: 3, display: "flex", gap: '14px'  }}>
            <Button
              sx={{ maxHeight: 56, textTransform: "capitalize" }}
              variant="contained"
              color="secondary"
              onClick={() => setIsFilter(true)}
            >
              Filtros
              <Box
                sx={{
                  backgroundColor: "#FBAF17",
                  color: "#fff",
                  fontWeight: 700,
                  borderRadius: 100,
                  height: 24,
                  width: 24,
                  textAlign: "center",
                  ml: 1,
                }}
              >
                {quantityFiltered}
              </Box>
            </Button>

            <FormControl>
              <Select
                sx={{
                  minWidth: 160, 
                  background: '#ffffff', 
                  textAlign: 'left', 
                  borderRadius: '8px',
                  "& .MuiSelect-select": {padding: '8px 32px'}
                }}
                multiple
                value={selectedStatus}
                displayEmpty
                onChange={(e) => handleChangeFilteredStatus(e.target.value)}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    Status
                    {statusStateOptions
                      .filter((option) => selected.includes(option.id_state))
                      .map((option) => (
                        <Box
                          key={option.id_state}
                          sx={{
                            width: 14,
                            height: 14,
                            borderRadius: "50%",
                            bgcolor: option.color,
                          }}
                        />
                      ))}
                  </Box>
                )}
              >
                {statusStateOptions.map((state) => (
                  <MenuItem key={state.id_state} value={state.id_state}>
                    <Checkbox checked={selectedStatus.includes(state.id_state)} />
                    <Typography
                      sx={{
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          width: 16,
                          height: 16,
                          borderRadius: "50%",
                          bgcolor: state.color,
                          flexShrink: 0,
                        }}
                      />
                      {state.ds_state}
                    </Typography>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {quantityFiltered > 0 && (
              <Button
                sx={{ maxHeight: 56, textTransform: "capitalize" }}
                variant="contained"
                color="secondary"
                onClick={clearFilter}
              >
                Limpar Filtros
              </Button>
            )}
          </Box>
        </Box>

        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: 'center' }}
        >
          <Box sx={{ mt: 3, display: "flex" }}>
            <Typography
              variant="h5"
              sx={{ fontWeight: 600, fontSize: 20 }}
            >
              Controle Solicitação Orçamento - Call Center
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
        >
          <Box sx={{ mt: 3, display: "flex" }}>
            {/* <TextField
              fullWidth
              sx={{ ml: 2, width: 300 }}
              inputProps={{ style: { padding: "8px 14px" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SvgIcon fontSize="small" color="action">
                      <SearchIcon />
                    </SvgIcon>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => {
                setTextosearch(e.target.value);
              }}
              placeholder="Pesquisar na tabela..."
              variant="outlined"
            /> */}
            <Button
              sx={{
                ml: 2,
                color: "#fff",
                fontWeight: 700,
                textTransform: "capitalize",
              }}
              onClick={() => setIsForm("callCenter")}
              color="tertiary"
              variant="contained"
            >
              Novo Orçamento
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

BudgetRequestListToolbar.propTypes = {
  budgets: PropTypes.array,
};

export default BudgetRequestListToolbar;
